module.exports = "/images/bl.svg?dac1c8ab0679f1167292bd481eec0494";